import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-teal-700/30 bg-zinc-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annwfzeukj47">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcsnzlejbd3">The {totalBonuses} <span className="text-orange-400" data-id="element-21" data-mp="15q5l62dcxrt1">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-teal-700/60 bg-zinc-950 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jhamra0acu60">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-teal-700/15 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzoiygswexv3" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-teal-400/50 bg-zinc-900 text-teal-400" data-id="element-24" data-mp="2jieja1p8zszh">
                  <Icon className="h-5 w-5 drop-shadow-[0_0_6px_rgba(45,212,191,0.55)]" aria-hidden="true" data-id="element-25" data-mp="1qth0zyl1dw6q" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-26" data-mp="1vtd3fte35fk6">
                  <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1" data-id="element-27" data-mp="1vu4y91zuz99e">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-orange-400" data-id="element-28" data-mp="20trdti35t1ld">Bonus {bonus.number}</p>
                    <p className="text-xs font-bold uppercase tracking-[.1em]" data-id="element-29" data-mp="3c6tsg7lp7h2w">
                      <span className="text-zinc-400 line-through decoration-orange-400 decoration-2" data-id="element-30" data-mp="3c8wll0i5dqbu">{bonusValue}</span>
                      <span className="ml-2 text-orange-400" data-id="element-31" data-mp="1h2vtuz4phx4a">FREE</span>
                    </p>
                  </div>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-32" data-mp="1c394jrblsqf4">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-zinc-300" data-id="element-33" data-mp="1q2sempnz6bu2">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-orange-400 bg-zinc-950 px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-34" data-mp="yce515mzvlo7">
          <div data-id="element-35" data-mp="175hd0yevf6bg">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-zinc-300" data-id="element-36" data-mp="1760wwko304s4">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-zinc-300 line-through decoration-orange-400 decoration-2" data-id="element-37" data-mp="12d7sxz0ft0h3">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-38" data-mp="amthe9fwc08l">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-zinc-300" data-id="element-39" data-mp="jo97qyzgb16">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-orange-400" data-id="element-40" data-mp="5amr2uzmdh6j">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-41" data-mp="3mre477227xw5" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}